import {UnstyledButton} from './button';
import {makeClassNameComponentCustom} from 'src/utils/makeClassNameComponent';

import css from './legacy.css';


export const LegacyButton = makeClassNameComponentCustom(
  css.legacy,
  UnstyledButton,
);
